import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { convertProsemirrorToMarkdown } from '@atlassian/ai-model-io/convert-prosemirror-to-markdown';
import { addAnalytics } from '../analytics/utils';
import { ErrorUtils } from '../utils/errors';
import { getContextSelectionScope } from './utils';
/**
 * Takes a prosemirror schema and (slice or node) and returns it as
 * markdown / markdown plus.
 * ```
 */
export function sliceOrNodeToMarkdown(_ref) {
  var slice = _ref.slice,
    node = _ref.node,
    editorView = _ref.editorView,
    convertTo = _ref.convertTo,
    updateIdMap = _ref.updateIdMap,
    selectionType = _ref.selectionType,
    mentionMap = _ref.mentionMap;
  var fragment = (slice || node).content;
  try {
    // we track whether the context is a whole document or a partial selection
    var contextSelectionScope = getContextSelectionScope({
      editorView: editorView,
      slice: slice,
      node: node
    });
    if (convertTo === 'markdown-plus') {
      var _convertProsemirrorTo = convertProsemirrorToMarkdown({
          editorView: editorView,
          fragment: fragment,
          featureToggles: {
            markdownPlus: true,
            markdownPlusExtensions: true,
            markdownPlusPanels: true,
            markdownPlusDecisions: true
          },
          mentionMap: mentionMap
        }),
        _markdown = _convertProsemirrorTo.markdown,
        idMap = _convertProsemirrorTo.idMap,
        fallbackState = _convertProsemirrorTo.fallbackState,
        _contentStatistics = _convertProsemirrorTo.contentStatistics;
      if (!!Object.keys(fallbackState).length) {
        var tr = addAnalytics({
          editorState: editorView.state,
          tr: editorView.state.tr,
          payload: {
            action: 'fallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'markdownSerializer',
            attributes: {
              fallbackState: fallbackState
            },
            eventType: EVENT_TYPE.OPERATIONAL
          }
        });
        tr.setMeta('addToHistory', false);
        editorView.dispatch(tr);
      }

      // This ID map is used to map the markdown back to the original ProseMirror
      // when we receive transformed content back from the llm.
      updateIdMap({
        idMap: idMap,
        selectionType: selectionType
      });
      return {
        markdown: _markdown,
        contentStatistics: _objectSpread(_objectSpread({}, _contentStatistics), {}, {
          contextSelectionScope: contextSelectionScope
        })
      };
    }
    var _convertProsemirrorTo2 = convertProsemirrorToMarkdown({
        editorView: editorView,
        fragment: fragment,
        featureToggles: {},
        mentionMap: mentionMap
      }),
      markdown = _convertProsemirrorTo2.markdown,
      contentStatistics = _convertProsemirrorTo2.contentStatistics;
    return {
      markdown: markdown,
      contentStatistics: _objectSpread(_objectSpread({}, contentStatistics), {}, {
        contextSelectionScope: contextSelectionScope
      })
    };
  } catch (e) {
    var _tr = addAnalytics({
      editorState: editorView.state,
      tr: editorView.state.tr,
      payload: {
        action: 'failed',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'markdownSerializer',
        attributes: {
          errorType: 'markdownSerializer',
          errorMessage: ErrorUtils.extractErrorMessage(e)
        },
        eventType: EVENT_TYPE.OPERATIONAL
      }
    });
    editorView.dispatch(_tr);
    return {
      markdown: '',
      contentStatistics: undefined
    };
  }
}